export default theme => ({
  multipleSelect: {
    marginTop: 0,
    marginBottom: 0,
  },
});
